import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Section, Link, SectionHeader, HashtagList, Image } from 'components';
import './CaseStudyBanner.scss';

const CaseStudyBanner = ({
  link,
  color,
  textColor,
  image,
  logo,
  title,
  tags,
  additionalClass,
  client,
}) => (
  <Section
    color={color}
    additionalClass={`case-study-banner ${additionalClass}`}
  >
    <Link to={link}>
      <div className={'case-study-banner__content'}>
        {logo && (
          <Image
            src={logo}
            alt={client}
            additionalClass={'case-study-banner__logo'}
          />
        )}
        <SectionHeader
          size={'medium'}
          color={textColor}
          lineColor={textColor}
          additionalClass={'case-study-banner__headline'}
          headingType={2}
        >
          {title}
        </SectionHeader>
        {tags && (
          <div className={'case-study-banner__tags'}>
            <HashtagList color={textColor || 'black'} data={tags} />
          </div>
        )}
      </div>
      {image && (
        <div
          className={`case-study-banner__image-wrapper case-study-banner__image-wrapper--${color}`}
        >
          <Image src={image} additionalClass={'case-study-banner__image'} />
        </div>
      )}
    </Link>
  </Section>
);

export default CaseStudyBanner;
